module.exports = __webpack_public_path__ + "img/terroir-moonlit-2.32684bb5.jpg";